export default class OfferingAppointment {
    static fromData(data, duplicate = false) {
        if (!data) {
            return;
        }

        let appointment = new OfferingAppointment();

        appointment.id = data.id || null;
        if (duplicate) {
            appointment.id = null;
        }
        appointment.start = data.start;
        appointment.end = data.end;
        appointment.interval = data.interval;
        appointment.intervalEnd = data.intervalEnd;
        appointment.weekday = data.weekday;

        Object.seal(appointment);
        return appointment;
    }

    equals(appointment) {
        if (appointment.id === null) {
            return false;
        }
        return appointment.id === this.id;
    }
}
